// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface FileSizeProhibited {
    fileSizeProhibited: boolean;
}
@Component({
    selector: 'file-size-error-PDDJ-modal',
    templateUrl: './file-size-error-PDDJ-modal.component.html',
    styleUrls: ['./file-size-error-modal.component.scss'],
})
export class FileSizeErrorPDDJModalComponent {
    constructor(
        private dialogRef: MatDialogRef<FileSizeErrorPDDJModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FileSizeProhibited
    ) {}

    @HostListener('window:keyup.Enter', ['$event'])
    onDialogClick(event: KeyboardEvent): void {
        this.close();
    }

    close() {
        this.dialogRef.close();
    }
}
